import './polyfills/index'

import conditioner from '@parallaxagency/conditioner'
import MicroModal from 'micromodal'
import Gumshoe from 'gumshoejs'
import detectIEEdge from './helpers/detectIEEdge'

import 'lazysizes/plugins/parent-fit/ls.parent-fit.js'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes'

// IE detection
var isIE = detectIEEdge()
if (isIE) {
  document.body.classList.add('is-ie')
} else {
  var spy1 = new Gumshoe('#sn-1 a')
  var spy2 = new Gumshoe('#sn-2 a')
  var spy3 = new Gumshoe('#sn-3 a')
}

conditioner.addPlugin({
  moduleSetName: name => `./components/${name}.js`,
  moduleGetConstructor: module => module.default,
  moduleImport: name => import(/* webpackChunkName: 'conditioner' */ `${name}`)
})
conditioner.hydrate(document.documentElement)

const menuBtn = document.querySelectorAll('.modal-trigger-button')
const closeBtn = document.querySelectorAll('[data-module=scroll]')

MicroModal.init({
  onShow: () => {
    menuBtn.forEach(btn => (btn.innerHTML = 'Close'))
  },
  onClose: () => {
    menuBtn.forEach(btn => (btn.innerHTML = 'Menu'))
  }
})

const closeModal = () => {
  document.getElementById('modal-1').classList.remove('is-open')
  menuBtn.forEach(btn => (btn.innerHTML = 'Menu'))
}

closeBtn.forEach(elem => {
  elem.addEventListener('click', closeModal)
})



// WEBPACK FOOTER //
// ./src/js/main.js